exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._8QWsH{float:right}._2fuuG{font-size:.875em;padding:16px 16px 14px;padding:16px 1rem 14px;display:inline-block;font-weight:500;text-decoration:none;text-transform:uppercase}._2fuuG,._2fuuG:active,._2fuuG:hover,._2fuuG:visited{color:#0b91cf}._20nvU{display:none}@media screen and (min-width:992px){._20nvU{margin-right:-1rem;display:block}}._2wtOW{display:block}@media screen and (min-width:992px){._2wtOW{display:none}}.gbg4a{border:0;padding:10px 16px 6px;padding:10px 1rem 6px;background-color:transparent;color:#0b91cf;-webkit-appearance:none}", ""]);

// exports
exports.locals = {
	"root": "_8QWsH",
	"link": "_2fuuG",
	"desktop": "_20nvU",
	"mobile": "_2wtOW",
	"toggle": "gbg4a"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":{"discardComments":{"removeAll":true}}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Header/Navigation.css
// module id = 656
// module chunks = 0 1 2 3 4